const updateRoles = {
  toastr: 'Updated function',
  toastr1: ' has been updated successfully',
  toastrError: 'Function already registered',
  toastrError1: 'Enter another name'
};

export default updateRoles;
